import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap';
import { UtilsModule } from '../utils/utils.module';
import { SharedModule } from './../shared/shared.module';
// Routing
import { LoginModuleRoutingModule } from './login-module-routing.module';
// Componentes de Login Layout
import { LoginComponent } from './login/login.component';
import { NuevaPasswordComponent } from './nueva-password/nueva-password.component';
import { PasswordResetComponent } from './nueva-password/password-reset.component';
import { RecoverComponent } from './recover/recover.component';


@NgModule({
  imports: [
    SharedModule,
    TranslateModule,
    LoginModuleRoutingModule,
    TooltipModule.forRoot(),
    UtilsModule
  ],
  declarations: [
    LoginComponent,
    RecoverComponent,
    NuevaPasswordComponent,
    PasswordResetComponent
  ]
})
export class LoginModule { }
